import { Zap } from "lucide-react";

const Marquee = ({ items, className = "" }) => (
  <div
    data-testid="editorial-marquee"
    className={`relative overflow-hidden border-y border-slate-200 bg-white/70 py-5 ${className}`}
    aria-hidden="true"
  >
    <div className="animate-marquee flex w-max items-center">
      {[...items, ...items].map((item, i) => (
        <span
          key={i}
          className="flex items-center whitespace-nowrap font-display text-xl sm:text-2xl font-bold uppercase tracking-[0.15em] text-[#0a2a6b]/10"
        >
          <span className="px-6">{item}</span>
          <Zap className="h-4 w-4 text-brand-blue/40" fill="currentColor" />
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
